import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #FCFDFF;
  border-radius: 4px;
  padding: 12px;
`;
